module.exports = __webpack_public_path__ + "img/img5.b76546e2.svg";